import React from "react";
import Link from "next/link";
import Icon from "./Icon";
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import InfoTiles from "../ui-components/InfoTiles";
import Banners from "../ui-components/Banners";
import {travelBannersPlacement} from '../../../components/travelHomepage';

export default function Footer({ context }) {
    const { org, config } = context;

    if (context.render === "embed") return null;

    const year = new Date().getFullYear();

    return (
        <>
        {!(context.page?.type === 'HOME' && travelBannersPlacement(context.travel) === 'top')
            && <Banners context={context} />}
        <InfoTiles context={context} />
        <footer className="tr-footer">
            <div className="tr-container">
                <div className="tr-footer__top">
                    {/* Logo + nom */}
                    {org.logo && (
                        <div className="tr-footer__logo">
                            <img src={org.logo} alt={org.name} />
                        </div>
                    )}
                    <div className="tr-footer__name">{org.name}</div>

                    {org.adresse && (
                        <div className="tr-footer__tagline">
                            {org.adresse}{org.ville ? `, ${org.ville}` : ""}
                        </div>
                    )}

                    {/* Réseaux sociaux */}
                    <div className="tr-footer__socials">
                        {config["social.whatsapp"] && (
                            <a href={config["social.whatsapp"]} aria-label="WhatsApp" target="_blank" rel="noopener noreferrer">
                                <Icon name="whatsapp" size={18} />
                            </a>
                        )}
                        {config["social.insta"] && (
                            <a href={config["social.insta"]} aria-label="Instagram" target="_blank" rel="noopener noreferrer">
                                <Icon name="instagram" size={18} />
                            </a>
                        )}
                        {config["social.fb"] && (
                            <a href={config["social.fb"]} aria-label="Facebook" target="_blank" rel="noopener noreferrer">
                                <Icon name="facebook" size={18} />
                            </a>
                        )}
                        {org.contact?.email && (
                            <a href={`mailto:${org.contact.email}`} aria-label="Email">
                                <Icon name="mail" size={18} />
                            </a>
                        )}
                        {org.contact?.tel && (
                            <a href={`tel:${org.contact.tel}`} aria-label={t`Téléphone`}>
                                <Icon name="phone" size={18} />
                            </a>
                        )}
                    </div>
                </div>

                <hr className="tr-footer__divider" />

                <div className="tr-footer__bottom">
                    <div>
                        © {year} {org.name}
                        {" · "}
                        <a href="/docs/CGU.pdf" target="_blank" rel="noopener noreferrer">
                            <Trans>CGU</Trans>
                        </a>
                        {" · "}
                        <a href="/docs/Politique-de-Confidentialité.pdf" target="_blank" rel="noopener noreferrer">
                            <Trans>Confidentialité</Trans>
                        </a>
                    </div>
                    <div className="tr-footer__powered">
                        <Trans>Propulsé par</Trans>{" "}
                        <a href="https://unisoft.world" target="_blank" rel="noopener noreferrer">
                            <span>Unisoft.world</span>
                        </a>
                    </div>
                </div>
            </div>
        </footer>
        </>
    );
}
